import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUserDevicesNotificationsV1Response } from './get-user-devices-notifications-v1-response';
import { getUserDevicesNotificationsV1ResponseSchema } from './get-user-devices-notifications-v1-response';

export async function getUserDevicesNotificationsV1Api(
  userId: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetUserDevicesNotificationsV1Response>> {
  return getRequest<IGetUserDevicesNotificationsV1Response>({
    path: `/sys/users/v1/${userId}/devices-notifications`,
    schema: getUserDevicesNotificationsV1ResponseSchema,
    options,
  });
}
